import React from "react";
export const Slider = ({ colorMain, colorDetail, size, info }) => (
	<svg width={size} className={info} fill="none" viewBox="0 0 24 24">
		<path stroke={colorMain} strokeLinecap="round" strokeWidth="1.5" d="M6 8.746h12M6 15.317h12" />
		<circle className="sliders" cx="7.5" cy="8.746" r="1.5" fill={colorDetail} stroke={colorDetail} strokeWidth="1.5" />
		<circle className="sliders-2" cx="16.5" cy="15.254" r="1.5" fill={colorDetail} stroke={colorDetail} strokeWidth="1.5" />
	</svg>
)